import React from 'react';
import type { Locale } from '@lib/locale';
import type { UserData } from '@lib/data-fetching';

type AnalyticsContextValue = {
  analyticsPageName?: string;
  userData: UserData;
  locale: Locale;
};

const AnalyticsPageContext = React.createContext<AnalyticsContextValue>({
  analyticsPageName: undefined,
  userData: {},
  locale: 'en',
});

const withAnalyticsPageName = <P extends object>(WrappedComponent: React.ComponentType<P & AnalyticsContextValue>) => {
  const WithAnalyticsPageName = (props: P) => (
    <AnalyticsPageContext.Consumer>
      {({ analyticsPageName, userData, locale }) => (
        <WrappedComponent
          {...props}
          analyticsPageName={analyticsPageName}
          userData={userData}
          locale={locale}
        />
      )}
    </AnalyticsPageContext.Consumer>
  );

  const wrappedComponentName = WrappedComponent.displayName
    || WrappedComponent.name
    || 'Component';
  WithAnalyticsPageName.displayName = `WithAnalyticsPageName(${wrappedComponentName})`;

  return WithAnalyticsPageName;
};

export {
  AnalyticsPageContext,
  withAnalyticsPageName,
};
